import type { Message } from '@replayio-app-building/help-widget'
import MarkdownLite from './MarkdownLite'

function formatTime(date: Date): string {
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

/** Message bubble matching help-widget styling, with markdown for assistant replies. */
export function HelpMessageBubble({ message }: { message: Message }) {
  const isUser = message.sender === 'user'

  return (
    <div
      className={`hw-message-bubble ${isUser ? 'user' : 'response'}`}
      data-testid={`message-bubble-${message.sender}`}
    >
      {isUser && message.elementContext && message.elementContext.componentChain.length > 0 && (
        <div className="hw-message-context-badge" data-testid="message-context-badge">
          {message.elementContext.componentChain[0]}
          {message.elementContext.componentChain.length > 1 && (
            <span> + {message.elementContext.componentChain.length - 1} more</span>
          )}
        </div>
      )}
      <div className="hw-message-bubble-text">
        {isUser ? message.text : <MarkdownLite text={message.text} className="help-message-markdown" />}
      </div>
      <div className="hw-message-bubble-time" data-testid="message-timestamp">
        {formatTime(message.timestamp)}
      </div>
    </div>
  )
}
